import { Card, type CardProps } from "../Card";
import { Copyright, type CopyrightProps } from "../Copyright";
import { Eisox } from "../Eisox";
import { cn } from "../index";

interface UnprotectedRouteResponsiveCardProps extends CardProps, Pick<CopyrightProps, "version" | "label"> {}

const UnprotectedRouteResponsiveCard: React.FC<UnprotectedRouteResponsiveCardProps> = ({
  version,
  label,
  className,
  children,
  ...props
}) => (
  <div className="flex h-dvh w-dvw items-center justify-center overflow-hidden">
    <Card
      {...props}
      className={cn(
        `gap-15 px-5 pt-10 pb-5 flex max-h-[calc(100%-20px)] max-w-[calc(100%-20px)] flex-col items-center rounded-[20px]`,
        className,
      )}
    >
      <Eisox />
      <div className="w-full flex-1 overflow-auto">{children}</div>
      <Copyright version={version} label={label} />
    </Card>
  </div>
);

export { UnprotectedRouteResponsiveCard };
export type { UnprotectedRouteResponsiveCardProps };
